import { render, staticRenderFns } from "./BuilderCategoriesForm.vue?vue&type=template&id=5d2fb611&scoped=true&"
import script from "./BuilderCategoriesForm.vue?vue&type=script&lang=js&"
export * from "./BuilderCategoriesForm.vue?vue&type=script&lang=js&"
import style0 from "./BuilderCategoriesForm.vue?vue&type=style&index=0&id=5d2fb611&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2fb611",
  null
  
)

export default component.exports